import { createContext, useState } from 'react';
import i18n from "../i18n";

export const getMesStatus = () => {
  return {
    EMPTY: { status: '', color: '', text: '' },
    SUCCES: {
      status: 'succes',
        color: 'succes',
        text: i18n.t('De wijzigingen zijn opgeslagen'),
    },
    ALERT: { status: 'alert', color: 'alert', text: i18n.t('Er is iets mis gegaan') },
    CUSTOM: { status: 'custom', color: 'primary' },
  }
}

const MessagebarContext = createContext();

export const getAnimationDuration = (text) => 2500 + text.length * 50;

export const MessagebarProvider = ({ children }) => {
  const [message, setMessage] = useState(getMesStatus().EMPTY);

  const setSuccesMessage = (value) => {
    const text = value ? value : getMesStatus().SUCCES.text;
    setMessage({ ...getMesStatus().SUCCES, text });
    setTimeout(() => {
      clearMessage();
    }, getAnimationDuration(text));
  };

  const setAlertMessage = (value) => {
    const text = value ? value : getMesStatus().ALERT.text;
    setMessage({...getMesStatus().ALERT, text});
    setTimeout(() => {
      clearMessage();
    }, getAnimationDuration(text));
  };

  const setCustomMessage = (value) => {
    setMessage({ ...getMesStatus().CUSTOM, text: value });
    setTimeout(() => {
      clearMessage();
    }, getAnimationDuration(value));
  };

  const clearMessage = () => setMessage(getMesStatus().EMPTY);

  return (
    <MessagebarContext.Provider
      value={{
        message,
        setSuccesMessage,
        setAlertMessage,
        setMessage,
        setCustomMessage,
        clearMessage,
      }}
    >
      {children}
    </MessagebarContext.Provider>
  );
};

export const MessagbarConsumer = MessagebarContext.Consumer;

export default MessagebarContext;
